import React from 'react';
import { object, number } from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from '@fiverr-private/fiverr_context';
import { getPackageById } from '../../../reducers/packages';
import { BASIC_PACKAGE_ID } from '../../../utils/packagesUtils/constants';
import ServiceFeeIcon from '../../PackagesTable/ServiceFeeIcon';

import './style.scss';

export const TotalPrice = ({ currentPrice }, { currencyConverter }) => {
    const formattedPrice = currencyConverter.convertWithFee(currentPrice);

    return (
        <div className="total-price wrapper">
            <span className="label"><I18n k="gig_page_perseus.packages.total_price"/></span>
            <div className="price-wrapper">
                <span className="price">{formattedPrice}</span>
                <ServiceFeeIcon packageId={BASIC_PACKAGE_ID}/>
            </div>
        </div>
    );
};

TotalPrice.propTypes = {
    currentPrice: number
};

TotalPrice.contextTypes = {
    currencyConverter: object
};

const mapStateToProps = ({ packages }) => {
    const { currentPrice } = getPackageById(packages, BASIC_PACKAGE_ID);

    return { currentPrice };
};

export default connect(mapStateToProps)(TotalPrice);
